import { gql } from '@apollo/client';
import GraphQL from '../graphQL';
import store from '@store/store';

const REORDER_SUPER_POWERS = gql`
    mutation ReorderSuperPowers($skillIds: [Int!]!) {
        reorderSuperPowers(skillIds: $skillIds)
    }
`;

export default async function reorderSuperPowers(skillIds: number[]): Promise<boolean> {
    const result = await GraphQL.mutate<{ reorderSuperPowers: boolean }>(REORDER_SUPER_POWERS, { skillIds });
    
    // Refetch employee to update UI
    const getEmployee = (await import('./getEmployee')).default;
    await getEmployee(store.getState().employee.id);
    
    return result.reorderSuperPowers;
}
